module.exports = __webpack_public_path__ + "img/tl.a3e552b9.svg";